export default __webpack_public_path__ + "static/media/DSC_0576.f4872830.jpg";